import { RouteObject } from "react-router";

import PageError from "@/shared/ui/errors/PageError";
import * as Sentry from "@sentry/react";

export const labRoutes: RouteObject = {
	path: "/lab/*",
	lazy: async () => {
		const { LabHome } = await import("./pages/LabHome");
		return {
			Component: () => (
				<Sentry.ErrorBoundary
					fallback={(boundary) => (
						<PageError
							error={boundary.error}
							componentStack={boundary.componentStack}
							reset={() => boundary.resetError()}
						/>
					)}
				>
					<LabHome />
				</Sentry.ErrorBoundary>
			),
		};
	},
	children: [
		{
			index: true,
			lazy: async () => {
				const { LabHome } = await import("./pages/LabHome");
				return { Component: LabHome };
			},
		},
		{
			path: "daily",
			lazy: async () => {
				const { LabHome } = await import("./pages/LabHome");
				return { Component: LabHome };
			},
		},
		{
			path: "samples",
			lazy: async () => {
				const { LabHome } = await import("./pages/LabHome");
				return { Component: LabHome };
			},
		},
		{
			path: "spot",
			lazy: async () => {
				const { LabHome } = await import("./pages/LabHome");
				return { Component: LabHome };
			},
		},
		{
			path: "search",
			lazy: async () => {
				const { LabHome } = await import("./pages/LabHome");
				return { Component: LabHome };
			},
		},
		{
			path: "reports",
			lazy: async () => {
				const { LabHome } = await import("./pages/LabHome");
				return { Component: LabHome };
			},
		},
		{
			path: "edit",
			lazy: async () => {
				const { LabHome } = await import("./pages/LabHome");
				return { Component: LabHome };
			},
			children: [
				{
					path: "group",
					lazy: async () => {
						const { LabEditGroup } = await import("./pages/LabEditGroup");
						return { Component: LabEditGroup };
					},
				},
				{
					path: "analysis",
					lazy: async () => {
						const { LabEditAnalysis } = await import("./pages/LabEditAnalysis");
						return { Component: LabEditAnalysis };
					},
				},
			],
		},
		{
			path: "settings",
			lazy: async () => {
				const { LabHome } = await import("./pages/LabHome");
				return { Component: LabHome };
			},
		},
	],
};
